module.exports = __webpack_public_path__ + "static/img/google.e961285.png";